import type { NormalisedRequest } from "@onhandtech/onhand-fe-shared/lib/api/v4/requests/requests.types";
import type { NormalisedTaskType } from "@onhandtech/onhand-fe-shared/lib/api/v4/task-types/task-types.types";
import type { NormalisedRequestFilterSet } from "@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/request-filter-set.types";
import type { ContentPublishStatus } from "constants/publish-status";

export const moduleName = "sections";

export type SectionPermissionType = "public" | "targeted";

export type SectionFilterType =
	| {
			type: "action";
			filter: NormalisedRequest;
	  }
	| {
			type: "task-type";
			filter: NormalisedTaskType;
	  };

export type SectionModalType =
	| "edit-section-name"
	| "delete-section"
	| "change-section-order"
	| "permissions"
	| "unpublish";

export type ModalSections = Record<
	SectionModalType,
	NormalisedRequestFilterSet | null
>;

export type PaginationProps = {
	pageNumber: number;
};

export type SectionState = {
	draftFilters: SectionFilterType[];
	selectedSection: NormalisedRequestFilterSet | null;
	activeFilterType: ContentPublishStatus;
	modals: ModalSections;
	automaticallyRemovingPublicPermission: boolean;
	pagination: PaginationProps;
};
